import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import Cupon from 'components/NewCart/Cupon'
import Loader from 'components/Loader'
import AddressFactory from 'factories/Address'
import StorageService from 'services/StorageService/'
import { idPromoVtex } from 'config/constants'
import { useViewportMediaQuery } from 'hooks'
import OrderSummary from './OrderSummary'
import Totals from './Totals'
import SecondaryCartButtons from '../SecondaryCartButtons'
import { throttle } from 'utils'
import { paymentInitial } from 'config';
import style from './style.scss' //NOSONAR

const maxAmount = 3000000
const alertAmmount = maxAmount - 50000
const idCencoPrime = 'fec4a6aa-fef6-4f10-be80-506b1b040845'
const discountPrefix = 'RET_AUTO -'
const discountPrefixPrime = 'CENCOPRIME'

const Totalizer = (props) => {
    if (!props.orderForm) return ''

    const { orderForm, isCatPayment, loading, forceShipping, alertAmount, disabled, successPage, children, isQuickPurchase, isCheckout} = props

    const [maxAmountPrice, setMaxAmountPrice] = useState(false)
    const [isSticky, setSticky] = useState(false);
    const isMobile = useViewportMediaQuery(1024)

    const totalizers = props.orderForm.totalizers ? props.orderForm.totalizers : []
    const customTitle = props.customTitle || 'Sub total';

    const _getTotalizerValue = (orderFrm, id) => {
        const items = totalizers.filter((item) => item.id === id)
        return items[0] ? Math.abs(items[0].value) : 0
    }

    const _getPromoCencoPrime = (orderForm) => {
        if (!orderForm?.ratesAndBenefitsData?.rateAndBenefitsIdentifiers?.length) return null

        const ratesAndBenefitsData = orderForm.ratesAndBenefitsData

        if (ratesAndBenefitsData.rateAndBenefitsIdentifiers.find((item) => item.id === idCencoPrime)) {
            let value = StorageService.getItem('cost_estimate')
            return value ? parseInt(value) : 4990
        }

        return null
    }

    const _getDiscountsColaborator = (items) => {
        return items.reduce((oldValue, item) => {
            let newValue = oldValue

            item.priceTags.map((price) => {
                if (price.identifier === idPromoVtex.colaborator) {
                    newValue += price.rawValue
                }
            })

            return Math.round(newValue)
        }, 0)
    }

    const getPickUpDiscount = (orderForm) => {
        const { rateAndBenefitsIdentifiers } = orderForm.ratesAndBenefitsData || []
        if (!(rateAndBenefitsIdentifiers && rateAndBenefitsIdentifiers.length)) return false
        let discountId = ''

        rateAndBenefitsIdentifiers.some((identifier) => {
            if (identifier.name && identifier.name.includes(discountPrefix)) {
                discountId = identifier.id
                return true
            }
        })

        const { items } = orderForm || []
        let total = 0

        items.forEach((item) => {
            if (item.priceTags.length) {
                item.priceTags.forEach((tag) => {
                    if (tag.identifier === discountId) {
                        total += tag.rawValue
                    }
                })
            }
        })

        return Math.abs(total)
    }

    const getPrimeDiscount = (orderForm) => {
        const { rateAndBenefitsIdentifiers } = orderForm.ratesAndBenefitsData || []

        if (!(rateAndBenefitsIdentifiers && rateAndBenefitsIdentifiers.length)) return false

        let discountId = '';

        rateAndBenefitsIdentifiers.some(identifier => {
            if(identifier.name && identifier.name.toUpperCase().includes(discountPrefixPrime) && !identifier.matchedParameters.slaIds) {
                discountId = identifier.id
                return true
            }
        })

        const { items } = orderForm || []
        let total = 0

        items.forEach(item => {
            if(item.priceTags.length) {
                item.priceTags.forEach(tag => {
                    if (tag.identifier === discountId) {
                        total += tag.rawValue
                    }
                })
            }
        })

        return Math.abs(total)
    }

    const getSlaSelected = (typeMethod) => {
        if (typeMethod === 'seller-1-sla-Express') return true

        const logisticsInfo = orderForm && orderForm.shippingData ? orderForm.shippingData.logisticsInfo : []
        const sla = AddressFactory.getSla(logisticsInfo)

        return sla && sla.length > 0 ? sla[0].deliveryWindow : false
    }

    const pickUpDiscount = getPickUpDiscount(orderForm)
    const PrimeDiscount = getPrimeDiscount(orderForm)

    const discounts = _getTotalizerValue(orderForm, 'Discounts')
    const subTotal = _getTotalizerValue(orderForm, 'Items')
    const discountTcencoOrderForm = _getTotalizerValue(orderForm, 'DiscountsTcenco')
    const shipping = _getTotalizerValue(orderForm, 'Shipping')
    const tcenco = _getTotalizerValue(orderForm, 'Tcenco')
    const discountColaborator = _getDiscountsColaborator(orderForm.items ? orderForm.items : [])

    const total = subTotal - discounts
    const method = StorageService.getItem('preselected_shipping_method')
    const selectedSla = getSlaSelected(method)
    const selectedDelivery = method && method === 'seller-1-sla-DespachoaDomicilio'
    const discountTcenco = discountTcencoOrderForm > 0 && ((subTotal && discounts !== discountTcencoOrderForm) || isCatPayment)
        ? discountTcencoOrderForm / 100 - (discountColaborator ? discountColaborator * -1 : 0) - (PrimeDiscount ? PrimeDiscount : 0)
        : 0
    const discount = discounts - (PrimeDiscount ? PrimeDiscount * 100 : 0) - (discountColaborator ? discountColaborator * -100 : 0) - (pickUpDiscount ? pickUpDiscount * 100 : 0)
    const promoCencoPrime = _getPromoCencoPrime(orderForm)

    useEffect(() => {
        const totalAmount = total / 100
        const maxPrice = '$' + Math.round(maxAmount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')

        if (totalAmount >= alertAmmount && totalAmount < maxAmount) {
            setMaxAmountPrice(false)
            alertAmount(maxAmount, false)
        } else if (totalAmount >= maxAmount) {
            setMaxAmountPrice(maxPrice)
            alertAmount(maxAmount, true)
        }
    }, [orderForm])

    const subtotalStyle = discount > 0 || (shipping >= 0 && selectedSla)
    const summary = useRef()
    const fixedTotalizer = useRef()

    useEffect(() => {
        if (isMobile) {
            if(typeof window !== 'undefined'){
                window.addEventListener('scroll', throttle(scrolling, 40));
            }
    
            return function cleanup(){
                window.removeEventListener('scroll', throttle(scrolling, 40));
            }
        }
    }, [isMobile]);

    const scrolling = () => {
        const bottomSummary = summary.current?.getBoundingClientRect()
        const topFixedTotalizer = fixedTotalizer.current?.getBoundingClientRect()
        const summaryBoundary = bottomSummary.height + bottomSummary.y

        if(topFixedTotalizer?.y <= summaryBoundary) {
            setSticky(false)
        } else {
            setSticky(true)
        }
    }


    const amount = parseFloat(parseFloat((total/100)*paymentInitial).toFixed(0));

    const totals = <Totals {...{
        discount,
        discountTcenco,
        disabled,
        discountColaborator,
        forceShipping,
        isCatPayment,
        maxAmountPrice,
        selectedSla,
        shipping,
        subTotal,
        subtotalStyle,
        successPage,
        tcenco,
        total,
        customTitle,
        amount,
        isCheckout,
        isSticky,
    }}
    />

    return (
        <div className='new-cart-totalizer'>
            {loading && (<div className="cart-totalizer-loader"><Loader /></div>)}
            {isMobile && (<SecondaryCartButtons orderForm={orderForm} />)}
            <Cupon orderform={orderForm} isQuickPurchase={isQuickPurchase}/>
            <OrderSummary
                ref={summary}
                {...{
                    discount,
                    discountColaborator,
                    discountTcenco,
                    forceShipping,
                    isCatPayment,
                    pickUpDiscount,
                    PrimeDiscount,
                    promoCencoPrime,
                    selectedDelivery,
                    selectedSla,
                    shipping,
                    subTotal,
                }}
            />
            {totals}
            {children}
            {isMobile && (
                <div className={`new-totalizer-fixed ${isSticky ? 'is-sticky' : ''}`} ref={fixedTotalizer}>
                    {totals}
                    {children}
                </div>
            )}
        </div>
    )
}

Totalizer.propTypes = {
    orderForm: PropTypes.object,
    disabled: PropTypes.object,
    isCatPayment: PropTypes.bool,
    forceShipping: PropTypes.bool,
    loading: PropTypes.bool,
    customTitle: PropTypes.string,
    alertAmount: PropTypes.func,
    children: PropTypes.node,
}

export default Totalizer
